"use client"

import { MessageSquareShare } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MessageSquareShareIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MessageSquareShareIcon = component(Icon)({
  as: MessageSquareShare,
})
